import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { UserGroups } from 'components/Settings/Components/UserGroups/components/userGroups';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const UserGroupsPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userGroups.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.userGroups.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <UserGroups />
            </MainContent>
        </PageContainer>
    );
};
